<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackup"
      placeholder="请选择课程类型"
      :style="width ? `width: ${width}` : ''"
    >
      <el-option
        v-for="item in list"
        :key="item.card_type"
        :label="item.card_type_name"
        :value="item.card_type"
      />
    </el-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { index } from '@/api/card-type';

export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    storeId: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    valueBackup: '',
    list: [],
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackup) this.valueBackup = value;
    },
    valueBackup(valueBackup) {
      if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    async getList() {
      const { isError, data } = await index({ store_id: this.storeId });
      if (!isError) this.list = data;
    },
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    this.valueBackup = this.value;
    this.getList();
  },
};
</script>
